export type TRoleType = 'ADMIN'

export const ROLE: Record<TRoleType, string> = {
	ADMIN: 'PhuongKhangIdentityAdminAdministrator',
}
